export default class PermissionsHelper {

  public static hasPermission(permission: string): boolean {
    if(permission === undefined) {
      //TODO hasPermission (admin, *, ....) return true
    }
    return true
  }
}
